{
  "manager": {
    "paymentScheduleConfiguration": {
      "paymentSchedule": "Payment Schedule",
      "loadingPaymentSchedule": "Loading payment schedule...",
      "statusNotStarted": "Not Started",
      "statusActive": "Active",
      "statusCanceled": "Canceled",
      "statusCompleted": "Completed",
      "paymentProgress": "Payment Progress",
      "paidOfTotal": "{paid} of {total}",
      "paymentsMade": "{done} of {count} payments made",
      "amountRemaining": "Amount Remaining:",
      "loadingPaymentDetails": "Loading payment details...",
      "everyInterval": "(every {count} {interval}",
      "paymentsTotal": "{count} payments total",
      "starting": "Starting",
      "period": "Period",
      "amount": "Amount",
      "total": "Total:",
      "confirmCancellation": "Confirm Cancellation",
      "cancelConfirmMessage": "Are you sure you want to cancel this payment plan? This action cannot be undone.",
      "keepPlan": "No, Keep Plan",
      "cancelling": "Cancelling...",
      "yesCancelPlan": "Yes, Cancel Plan",
      "cancelPaymentPlan": "Cancel Payment Plan",
      "selectPaymentSchedule": "Select a Payment Schedule",
      "noSchedulesAvailable": "No Payment Schedules Available",
      "noSchedulesMessage": "There are no payment schedules configured for this registration opportunity prices. You need to create a payment schedule for a specific price before adding a user to it.",
      "paymentSchedulePreview": "Payment Schedule Preview",
      "previewReviewMessage": "Review the details of your selected payment schedule before confirming.",
      "planLabel": "Plan:",
      "standardPaymentPlan": "Standard Payment Plan",
      "startsAtLabel": "Starts At:",
      "totalAmountLabel": "Total Amount:",
      "paymentIntervalLabel": "Payment Interval:",
      "numberOfPaymentsLabel": "Number of Payments:",
      "pastStartDetected": "Past Start Date Detected",
      "proratedInfo": "Since the payment schedule's start date is in the past, you'll start with the current period. Past periods won't be charged, and a discount of {amount} will be applied to your next payment.",
      "backdatedRequired": "Backdated Payments Required",
      "backdatedInfo": "Since the payment schedule's start date is in the past, you'll be charged immediately for {count} past payment(s) totaling {amount}. Future payments will continue on the regular schedule.",
      "paymentScheduleOption": "Payment Schedule Option",
      "proratedOption": "Prorated - Start with current period and apply credit for elapsed time",
      "backdatedOption": "Backdated - Charge for all periods from original start date",
      "date": "Date",
      "status": "Status",
      "firstPayment": "First payment",
      "currentPeriod": "Current period",
      "pastDateNotCollected": "Past date - not collected",
      "pastDateWillBeCharged": "Past date - will be charged",
      "includesDiscount": "Includes {amount} discount",
      "pastDateBadge": "Past Date",
      "backdatedBadge": "Backdated",
      "initialPayment": "Initial Payment",
      "currentPeriodBadge": "Current Period",
      "discountedBadge": "Discounted",
      "scheduledBadge": "Scheduled",
      "totalFuturePayments": "Total (future payments):",
      "totalAllPayments": "Total (all payments):",
      "immediateCharge": "Immediate charge (backdated payments):",
      "confirming": "Confirming...",
      "confirmPaymentPlan": "Confirm Payment Plan",
      "noPlanConfigured": "No Payment Plan Configured",
      "noPlanMessage": "Set up a payment plan to split the total cost into multiple payments.",
      "addingPlan": "Adding Plan...",
      "addPaymentPlan": "Add Payment Plan",
      "pluralSuffix": "s"
    },
    "badgePaymentSource": {
      "online": "Online",
      "pos": "POS",
      "offline": "Offline"
    },
    "badgeStatus": {
      "datesNotSet": "Dates not set"
    },
    "charge": {
      "cardErrorHeading": "The following error occurred processing your card:",
      "cardErrorHelp": "Please verify your card details and try again or contact support if failure continues.",
      "nameLabel": "Name *",
      "namePlaceholder": "Your billing name",
      "nameRequired": "A name is required.",
      "emailLabel": "Email",
      "emailPlaceholder": "Email",
      "receiptNote": "A receipt will be sent to this email upon successful charge.",
      "addressLabel": "Address *",
      "addressPlaceholder": "Your billing address",
      "addressRequired": "An address is required.",
      "addressTwoLabel": "Address 2",
      "addressTwoPlaceholder": "Suite or Apartment #",
      "cityLabel": "City *",
      "cityPlaceholder": "Your billing city",
      "cityRequired": "A city is required.",
      "postalLabel": "Postal Code *",
      "postalPlaceholder": "Your postal code",
      "postalRequired": "A postal code is required.",
      "provinceLabel": "Province *",
      "provinceAlberta": "Alberta",
      "provinceBritishColumbia": "British Columbia",
      "provinceManitoba": "Manitoba",
      "provinceNewBrunswick": "New Brunswick",
      "provinceNewfoundlandAndLabrador": "Newfoundland and Labrador",
      "provinceNovaScotia": "Nova Scotia",
      "provinceOntario": "Ontario",
      "provincePrinceEdwardIsland": "Prince Edward Island",
      "provinceQuebec": "Quebec",
      "provinceSaskatchewan": "Saskatchewan",
      "provinceNorthwestTerritories": "Northwest Territories",
      "provinceNunavut": "Nunavut",
      "provinceYukon": "Yukon",
      "provinceRequired": "A province is required.",
      "countryLabel": "Country *",
      "countryCanada": "Canada",
      "countryRequired": "A country is required.",
      "completeChargeButton": "Complete {'$'}{amount} charge"
    },
    "paymentCard": {
      "billingAddress": "Billing Address",
      "paymentMethod": "Payment Method"
    }
  },
  "guest": {
    "addMembersPrompt": {
      "nextStepsTitle": "Next Steps",
      "membershipActiveBody": "Your membership is now active. Should you wish to add more members, such as family members, to your account, please click the button below.",
      "addAdditionalMembers": "Add Additional Members",
      "helpfulTip": "Helpful Tip",
      "keepInfoUpToDate": "Keep your address and personal information up-to-date in your account settings.",
      "viewAccountSettings": "View account settings"
    },
    "checkoutComplete": {
      "completedMessage": "Checkout completed! Please check your email for verification."
    },
    "checkoutItemPurchased": {
      "paymentPlan": "Payment Plan"
    },
    "checkoutItemTotal": {
      "total": "Total"
    },
    "checkoutOverlayContainer": {
      "cartTitle": "Your Cart",
      "timeRemaining": "Time remaining",
      "cartExpired": "Your cart has expired. Please re-add items to continue.",
      "emptyCart": "You have no items in your cart.",
      "clearCart": "Clear cart"
    },
    "checkoutPaymentPlan": {
      "paymentSchedule": "Payment Schedule",
      "paymentsOf": "payments of",
      "scheduleTotal": "Schedule Total"
    },
    "checkoutPreview": {
      "checkout": "Checkout"
    },
    "checkoutSummary": {
      "paymentsOf": "payments of",
      "scheduleTotal": "Schedule Total",
      "subtotal": "Subtotal",
      "discount": "Discount",
      "processingFee": "Processing Fee",
      "parentFeeExplanation": "{parentTenantName} charges this fee to help support the software provided to {childTenantName}.",
      "processingFeeExplanation": "Processing fees are charged by payment companies like Visa and PayPal.",
      "amountDueToday": "Amount Due Today",
      "total": "Total",
      "autoRenewal": "Auto-Renewal",
      "enabled": "Enabled",
      "totalProgramCost": "Total Program Cost"
    },
    "cartItem": {
      "product": "Product",
      "linkedToBooking": "(Linked to booking)",
      "unitPrice": "Unit price:",
      "maxQuantity": "Max quantity:",
      "tax": "Tax:",
      "taxApplied": "Applied",
      "taxNotApplied": "Not applied",
      "maximumQuantityReached": "Maximum quantity reached",
      "moreAvailable": "{count} more available",
      "participant": "Participant:",
      "monthlySuffix": " monthly",
      "weeklySuffix": " weekly",
      "guestsPlural": "{count} guests",
      "guestSingular": "{count} guest"
    },
    "cartSummaryFooter": {
      "total": "Total",
      "taxesCalculatedAtCheckout": "Taxes calculated at checkout.",
      "checkout": "Checkout",
      "continueShopping": "Continue Shopping"
    },
    "checkoutProcessing": {
      "backToCheckout": "Back to Checkout"
    },
    "checkoutSuccess": {
      "title": "Checkout Completed",
      "backToMemberArea": "Back to Member Area",
      "success": "Your checkout has successfully completed! Review your items below.",
      "emailDetails": "You will receive an email with further details about your transaction. Thank you!"
    },
    "checkoutWaivers": {
      "loading": "Loading {term}...",
      "noneRequired": "No {term} required for this checkout.",
      "alreadyAgreed": "Already agreed",
      "agreedOn": "on",
      "step1Read": "Step 1: Read",
      "step2Hint": "Step 2 will be enabled after you open the {term}.",
      "step2Agree": "Step 2: Agree",
      "iAgreeToThis": "I agree to this {term}",
      "completeStep1First": "Complete Step 1 first.",
      "agreeAndContinue": "Agree & Continue to Checkout",
      "stepOneNumber": "1",
      "stepTwoNumber": "2"
    }
  },
  "user": {
    "checkoutContainer": {
      "billingAddressTitle": "Billing Address",
      "paymentInformationTitle": "Payment Information",
      "requestNotCharged": "Your card will not be charged. An administrator will review your request and contact you with the next steps.",
      "completeSignupPrompt": "Click the button below to complete your signup.",
      "completeSignup": "Complete signup",
      "transactionErrorHeading": "The following error occurred processing your transaction:",
      "missingInformation": "Missing information",
      "missingInformationDetail": "Please fill all required address fields below before proceeding.",
      "freeCheckoutNotice": "Your cart total is {'$'}0.00 therefore no payment information is required.",
      "freeCheckoutPrompt": "Please click the button below to complete your checkout.",
      "completeCheckout": "Complete Checkout",
      "customAmountPlaceholder": "Other",
      "autoRenewMembership": "Auto-Renew Membership",
      "autoRenewDescription": "Renews automatically when it expires",
      "autoRenewEnabled": "Auto-renewal enabled. You can change this anytime from your account.",
      "processing": "Processing…",
      "orderSummary": "Order Summary",
      "promoCode": "Promo Code"
    },
    "checkoutPaymentOptions": {
      "backToPaymentOption": "Back to Payment Option",
      "payByCreditCard": "Pay By Credit Card",
      "secureOnlinePayment": "Secure online payment"
    },
    "checkoutPromoCode": {
      "enterPromoCode": "Enter your promo code",
      "removeCode": "Remove code"
    }
  },
  "addPromoCode": "Add promo code",
  "encryptedSecure": "Encrypted & secure",
  "poweredByStripe": "Powered by Stripe",
  "emailLabel": "Email",
  "cardInformationLabel": "Card information",
  "billingAddressLabel": "Billing address",
  "backToPaymentOptions": "Back to Payment Options",
  "payByCreditCard": "Pay By Credit Card",
  "securePayment": "Secure online payment"
}
